import { render } from "./TheStopwatch.vue?vue&type=template&id=60d827fe"
import script from "./TheStopwatch.vue?vue&type=script&lang=js"
export * from "./TheStopwatch.vue?vue&type=script&lang=js"
script.render = render

export default script